import React from 'react';
import './OrderCard.css';

const statusColors = {
  'Pendiente': 'var(--status-pendiente)',
  'Preparando': 'var(--status-preparando)',
  'Empaquetando': 'var(--status-empaquetando)',
  'Proceso de Entrega': 'var(--status-proceso-entrega)',
  'Entregado': 'var(--status-entregado)'
};

const OrderCard = ({ order, onStatusChange, onDelete, onStatusChangeSound, onOpenEditModal  }) => {
  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    onStatusChange(order.id, newStatus);
    
    if (newStatus === 'Pendiente') {
        onStatusChangeSound();
    }
  };

  const handleDeleteClick = () => {
    if (window.confirm(`¿Estás seguro de que quieres borrar la orden de ${order.customer_name}? Esta acción no se puede deshacer.`)) {
      onDelete(order.id);
    }
  };

  const handleCardClick = (e) => {
    // Evita que al hacer clic en los botones internos se abra también el modal
    if (e.target.closest('.delete-btn') || e.target.closest('.status-dropdown')) {
      return;
    }
    onOpenEditModal(order);
  };

  return (
    <div className="order-card" onClick={handleCardClick}>
      <div className="card-header">
        <span className="customer-name">{order.customer_name || 'Cliente sin nombre'}</span>
        {/* --- AÑADIMOS EL BOTÓN DE BORRAR --- */}
        <button onClick={handleDeleteClick} className="delete-btn">×</button>
      </div>
      <div className="order-type">
        <span>{order.delivery_type}</span>
        <span className="order-time">{order.hora || ''}</span>
      </div>

      {order.total && (
        <div className="order-total">
          Total: <strong>${order.total.toFixed(2)}</strong>
        </div>
      )}

      {order.delivery_type === 'A domicilio' && order.address && (
        <div className="order-address">
          <strong>Dirección:</strong> {order.address}
        </div>
      )}

      <div className="order-items">
        {order.items && order.items.map((item, index) => (
          <p key={index}>
            {item.quantity}x {item.name} 
            {item.notes && <span className="item-notes"> ({item.notes})</span>}
          </p>
        ))}
      </div>
      <div className="card-footer">
        <select 
            className="status-dropdown" 
            value={order.status}
            onChange={handleStatusChange}
            style={{ 
                backgroundColor: statusColors[order.status] || '#ccc', 
                borderColor: statusColors[order.status] || '#ccc' 
            }}
        >
          <option value="Pendiente">Pendiente</option>
          <option value="Preparando">Preparando</option>
          <option value="Empaquetando">Empaquetando</option>
          <option value="Proceso de Entrega">Proceso de Entrega</option>
          <option value="Entregado">Entregado</option>
        </select>
      </div>
    </div>
  );
};

export default OrderCard;